var React = require('react');

function CloseV2 (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"28.9531","y1":"11.2751","x2":"11.2755","y2":"28.9528","stroke":"black","strokeWidth":"3","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"11.2756","y1":"10.645","x2":"28.9533","y2":"28.3227","stroke":"black","strokeWidth":"3","strokeLinecap":"round","key":1})]);
}

CloseV2.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = CloseV2;

CloseV2.default = CloseV2;
